import { Configuration, LedgersApi, SearchLedgerDetailsParamsDto } from '@inosio/payments-sdk';
import { getAllOwnerLedgers, getOwnerLedgerDetailItems, setAllOwnerLedgers, setAllOwnerLedgersFetchError, setOwnerLedgerDetailItems, setOwnerLedgerDetailItemsFetchError } from './OwnerLedgerSlice';
import { IpaUserExtended, selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

const { REACT_APP_IPA_BASE_PATH } = process.env;

export function requestAllOwnerLedgers(accessToken: string, ledgerEntityOwnerUuid: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });
  const ipaOwnerAPI = new LedgersApi(apiConfig);
  return ipaOwnerAPI.getAllLedgers(ledgerEntityOwnerUuid);
}

export function requestOwnerLedgerDetailItems(accessToken: string, searchLedgerDto: SearchLedgerDetailsParamsDto, ledgerUuid: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken,
  });
  const ipaOwnerAPI = new LedgersApi(apiConfig);
  return ipaOwnerAPI.searchLedgerDetails(ledgerUuid, searchLedgerDto);
}

export function* handleFetchOwnerLedgerDetailItems(action: { type: typeof getOwnerLedgerDetailItems; payload: { ledgerUuid: string; ledgerDetailsSearchParams: SearchLedgerDetailsParamsDto } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestOwnerLedgerDetailItems, currentUser.accessToken, action.payload.ledgerDetailsSearchParams, action.payload.ledgerUuid);
    const { data } = response;
    yield put(setOwnerLedgerDetailItems(data));
  } catch (error: any) {
    yield put(
      setOwnerLedgerDetailItemsFetchError({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* handleFetchAllOwnerLedgers(action: { type: typeof getAllOwnerLedgers; payload: string }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<any> = yield call(requestAllOwnerLedgers, currentUser.accessToken, action.payload);
    const { data } = response;
    yield put(setAllOwnerLedgers(data));
  } catch (error: any) {
    yield put(
      setAllOwnerLedgersFetchError({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode,
      }),
    );
  }
}

export function* ownerLedgerSaga() {
  yield takeLatest(getOwnerLedgerDetailItems.type, handleFetchOwnerLedgerDetailItems);
  yield takeLatest(getAllOwnerLedgers.type, handleFetchAllOwnerLedgers);
}
